import { useState } from 'react';
import { ThemeProvider } from 'styled-components';
import { getTheme, Theme } from '../theme';
import TooltipBody, { TooltipBodyProps } from './TooltipBody';

var idCounter = 1;

export const _UITooltipController = {
    tooltips: [] as TooltipBodyProps[],
    tooltipsById: {} as { [id: TooltipBodyProps['id']]: TooltipBodyProps },
    subscriptions: [] as (() => void)[],
    subscribe(callback: () => void): () => void {
        this.subscriptions.push(callback);
        return () => this.subscriptions = this.subscriptions.filter(subscription => subscription !== callback);
    },
    add(props: Omit<TooltipBodyProps, 'id'>): number {
        if (this.tooltips.some(tooltip => tooltip.target === props.target)) return 0;
        (props as TooltipBodyProps).id = idCounter++;
        const tooltip = props as TooltipBodyProps;
        this.tooltips.push(tooltip);
        this.tooltipsById[tooltip.id] = tooltip;
        this.push();
        return tooltip.id;
    },
    update(id: TooltipBodyProps['id'], props: { [key in keyof TooltipBodyProps]?: TooltipBodyProps[key] }) {
        if (!this.tooltipsById[id]) return;
        (Object.keys(props) as (keyof TooltipBodyProps)[]).forEach((key) => (this.tooltipsById[id][key] as any) = props[key])
    },
    remove(id: TooltipBodyProps['id']) {
        this.tooltips = this.tooltips.filter(tooltip => tooltip.id !== id);
        delete this.tooltipsById[id];
        this.push();
    },
    controllerRender: null as (() => void) | null,
    push() {
        this.subscriptions.forEach((subscription) => subscription());
        if (this.controllerRender) this.controllerRender();
    }
}

export default function TooltipController() {
    const [tooltips, setTooltips] = useState<TooltipBodyProps[]>([]);
    const [theme,] = useState<Theme>(getTheme);
    function render() {
        setTooltips([..._UITooltipController.tooltips])
    }
    _UITooltipController.controllerRender = render;
    return (
        <ThemeProvider theme={theme}>
            {tooltips.map(tooltip => <TooltipBody key={tooltip.id} {...tooltip}></TooltipBody>)}
        </ThemeProvider>
    )
}
